import { Custom } from '@app/shared/dynamic-form';
import { Injectable } from '@angular/core';
import { BaseControl, Textbox, EtapaBase } from '@app/shared';
import { Validators } from '@angular/forms';
import { EtapaDetalleApi } from '../../../../../shared/models/tramite.model';
import { InfoSuspension } from '../time-suspensions.component';

@Injectable()
export class TimeSuspensionsFormService {
  constructor() { }


  /**
   * Retorna el formulario de la suspension basado en un formulario de la tarea
   *
   * @param {InfoSuspension} [timeSuspension]
   * @return {*}  {BaseControl<any>[]}
   * @memberof TimeSuspensionsFormService
   */
  getFormSuspensionByTaskForm(timeSuspension?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'alias_formulario',
        value: timeSuspension && timeSuspension.datos_formulario ? timeSuspension.datos_formulario.alias_formulario : '',
        label: 'Alias del formulario',
        placeholder: 'Ingrese el alias del formulario',
        order: 1,
        validations: {
          validators: [
            Validators.required,
            Validators.pattern('^[a-z,A-Z,_]+$')
          ],
          messages: {
            pattern: 'Caracteres invalidos: solo letras y guiones bajos'
          }
        }
      }), 
      new Textbox({
        key: 'fecha',
        value: timeSuspension && timeSuspension.datos_formulario ? timeSuspension.datos_formulario.fecha : '',
        label: 'Alias del campo fecha',
        placeholder: 'Ingrese el alias del campo fecha',
        order: 2,
        validations: {
          validators: [
            Validators.required,
            Validators.pattern('^[a-z,A-Z,_]+$')
          ],
          messages: {
            pattern: 'Caracteres invalidos: solo letras y guiones bajos'
          }
        }
      }),
      new Textbox({
        key: 'motivo',
        value: timeSuspension && timeSuspension.datos_formulario ? timeSuspension.datos_formulario.motivo : '',
        label: 'Alias del campo motivo',
        placeholder: 'Ingrese el alias del campo motivo',
        order: 3,
        validations: {
          validators: [
            Validators.pattern('^[a-z,A-Z,_]+$')
          ],
          messages: {
            pattern: 'Caracteres invalidos: solo letras y guiones bajos'
          }
        }
      }),
      new Textbox({
        key: 'finaliza_suspension',
        type: 'checkbox',
        value: timeSuspension && timeSuspension.finaliza_suspension ? timeSuspension.finaliza_suspension : false,
        label: '¿Finaliza la suspensión?',
        order: 4
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Retorna el formulario de la suspension basado en un formulario de la tarea
   *
   * @param {InfoSuspension} [timeSuspension]
   * @return {*}  {BaseControl<any>[]}
   * @memberof TimeSuspensionsFormService
   */
  getFormSuspensionByTaskCondition(timeSuspension?: InfoSuspension): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'alias_condicion',
        value: timeSuspension && timeSuspension.datos_formulario ? timeSuspension.datos_formulario.alias_condicion : '',
        label: 'Alias del campo condición',
        placeholder: 'Ingrese el alias del campo condición para iniciar la suspensión',
        order: 1,
        validations: {
          // validators: [Validators.required]
          validators: [
            Validators.pattern('^[a-z,A-Z,_]+$')
          ],
          messages: {
            pattern: 'Caracteres invalidos: solo letras y guiones bajos'
          }
        }
      }), 
      new Textbox({
        key: 'opcion',
        value: timeSuspension && timeSuspension.datos_formulario ? timeSuspension.datos_formulario.opcion : '',
        label: 'Condiciones que inician la suspensión',
        placeholder: 'Ingrese las opciones separadas por ","',
        order: 2,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'finaliza_suspension',
        type: 'checkbox',
        value: timeSuspension && timeSuspension.finaliza_suspension ? timeSuspension.finaliza_suspension : false,
        label: '¿Finaliza la suspensión?',
        order: 3
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Retorna el formulario de la suspension basado en un formulario de la tarea
   *
   * @param {InfoSuspension} [timeSuspension]
   * @return {*}  {BaseControl<any>[]}
   * @memberof TimeSuspensionsFormService
   */
   getFormSuspension(timeSuspension?: InfoSuspension): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'finaliza_suspension',
        type: 'checkbox',
        value: timeSuspension && timeSuspension.finaliza_suspension ? timeSuspension.finaliza_suspension : false,
        label: '¿Finaliza la suspensión?',
        order: 1
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/time-control/time-suspensions/shared/time-suspensions.form.service.ts